import SectionHeading from "./SectionHeading";

const debates = [
  {
    tag: "算法透明度",
    icon: "ri-robot-2-line",
    question: "推荐机制是否该公开？",
    leftSide: "用户质疑",
    left: "流量忽高忽低，怀疑被算法「隐藏限流」。多次要求公开判定依据与申诉路径。",
    rightSide: "平台回应",
    right: "称推荐基于内容质量模型，无人工「黑箱」干预，正改进申诉与解释页面。",
    status: "双方仍存分歧",
    hot: true,
  },
  {
    tag: "处罚责任边界",
    icon: "ri-account-pin-circle-line",
    question: "主播违规，平台该担责吗？",
    leftSide: "监管关注",
    left: "监管要求平台压实内容主体责任，对违规直播采取更严厉的连带处理措施。",
    rightSide: "平台口径",
    right: "表示已建立分级处置机制，但强调「平台不能包办一切」，需要各方共同治理。",
    status: "规则仍在细化",
    hot: false,
  },
  {
    tag: "审核尺度争议",
    icon: "ri-scales-3-line",
    question: "同一内容为何时删时留？",
    leftSide: "创作者质疑",
    left: "相同表述在不同时间判定结果不一，审核缺乏一致标准，创作者难以预期。",
    rightSide: "平台解释",
    right: "回应称审核需结合语境与时间背景，正在推进更统一的规则库建设。",
    status: "讨论持续升温",
    hot: false,
  },
];

export default function RegulationDebate() {
  return (
    <section id="debate" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          kicker="监管与审核议题解析"
          title="监管争议 · 立场对开"
          desc="每一场风波背后都有两套说辞。我们把监管要求、创作者质疑与平台回应并排放置，由你来判断谁更接近真相。"
          accent
        />

        <div className="mt-8 grid w-full grid-cols-1 gap-5 lg:grid-cols-3">
          {debates.map((d) => (
            <article
              key={d.question}
              className="flex flex-col rounded-xl border border-background-200 bg-background-100 p-5"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
                  <i className={`${d.icon} text-base`} />
                </span>
                <span
                  className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${
                    d.hot ? "bg-accent-100 text-accent-900" : "bg-secondary-100 text-secondary-900"
                  }`}
                >
                  {d.hot && <i className="ri-fire-fill text-accent-600" />}
                  {d.tag}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950">{d.question}</h3>

              <div className="mt-4 flex flex-1 flex-col gap-3">
                <div className="rounded-lg border-l-2 border-primary-400 bg-primary-50 p-3">
                  <p className="font-label text-xs font-bold text-primary-700">{d.leftSide}</p>
                  <p className="mt-1 text-[13px] leading-relaxed text-foreground-700">{d.left}</p>
                </div>
                <div className="rounded-lg border-l-2 border-foreground-300 bg-background-50 p-3">
                  <p className="font-label text-xs font-bold text-foreground-800">{d.rightSide}</p>
                  <p className="mt-1 text-[13px] leading-relaxed text-foreground-700">{d.right}</p>
                </div>
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                  <i className="ri-flag-line text-accent-600" /> {d.status}
                </span>
                <span className="whitespace-nowrap text-xs font-semibold text-primary-600">参与讨论 →</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}